module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_15.798d723e.jpeg";